import { MimeType, ContentSource, Contents } from "js/models";

export interface DirectoryItem {
    displayName: string;
    path: string;
}

export enum FileType {
    AUDIO = "audio",
    VIDEO = "video",
    IMAGE = "image"
}

export interface BaseUIMediaContent {
    identifier: string;
    DisplayName: string;
}

export interface MediaContentRendererProps {
    media: UIMediaContent;
    isChecked: boolean;
    selectionType: "file" | "folder";
    onItemClick: (media: UIMediaContent) => void;
    onChosen: (media: UIMediaContent) => void;
    onChecked: (media: UIMediaContent, checked: boolean) => void;
    onDelete: (media: UIMediaContent) => void;
    onRename: (media: UIMediaContent) => void;
}

export interface MediaContentRendererContainerProps
    extends Omit<MediaContentRendererProps, "onChecked"> {
    checkedValues: (number | string)[];
    objectListings: UIMediaContent[];
    showPrevious: boolean;
    onPrevious: () => void;
    onCheckedValuesChange: (value: string[]) => void;
}

export interface BucketUIMediaContent extends BaseUIMediaContent {
    detail: ContentSource;
    type?: "bucket";
}

export interface DirectoryUIMediaContent extends BaseUIMediaContent {
    LastModified: number;
    CreatedAt: number;
    /** Size in bytes of the object */
    Size: number;
    detail: Contents;
    type?: "folder";
}

export interface FileUIMediaContent extends BaseUIMediaContent {
    LastModified: number;
    thumbnailUrl: string;
    CreatedAt: number;
    /** Size in bytes of the object */
    Size: number;
    Url: string;
    detail: Contents;
    type?: "file";
}

export type UIMediaContent = DirectoryUIMediaContent | FileUIMediaContent;

export function toUIMediaContent(content: Contents): UIMediaContent {
    const c = content;
    if (c.mimeType === null) {
        return {
            type: "folder",
            CreatedAt: c.createdAt,
            DisplayName: c.name,
            LastModified: c.modifiedAt,
            Size: c.size,
            detail: c,
            identifier: c.identifier
        };
    } else {
        return {
            type: "file",
            CreatedAt: c.createdAt,
            thumbnailUrl: c.metadata && c.metadata.thumbnailUrl,
            DisplayName: c.name,
            LastModified: c.modifiedAt,
            Size: c.size,
            detail: c,
            Url: c.url,
            identifier: c.identifier
        };
    }
}
export function convertMimeToExt(mimeType: MimeType): string {
    if (mimeType === MimeType.JPEG) {
        return "jpg";
    } else if (mimeType === MimeType.MP4) {
        return "mp4";
    } else if (mimeType === MimeType.PNG) {
        return "png";
    } else if (mimeType === MimeType.Webm) {
        return "webm";
    } else if (mimeType === MimeType.GIF) {
        return "gif";
    } else {
        return "";
    }
}

export interface ShareItemInterface {
    root: string;
    generatedFilesRoot: string;
    identifier?: string;
    name?: string;
    permission?: string;
    logo?: string;
}

export enum PermissionTypeEnum {
    WRITE = "write",
    READ = "read"
}
